
import * as user from "./user/index";
import { store as relations } from "./relations/index";

export const USERS_MODULE = {
  namespaced: true,
  state: { ...user.state, ...relations.state },
  mutations: { ...user.mutations, ...relations.mutations },
  actions: { ...user.actions, ...relations.actions },
  getters: { ...user.getters, ...relations.getters },
};